import { Img } from "react-image";
import { useSelector } from "react-redux";

import { formatDateForPanelDisplay } from "../../../../Utils/helper";
import UserChatBubble from "../../../Forms/FirmUserBtn";

import { BrokenPreviewImage } from "./photo-view-card";

function mixColorWithWhite(hex, percentage) {
  const whitePercentage = (100 - percentage) / 100;

  let r = parseInt(hex?.slice(1, 3), 16);
  let g = parseInt(hex?.slice(3, 5), 16);
  let b = parseInt(hex?.slice(5, 7), 16);

  // Mix each channel with white
  r = Math.floor(r + (255 - r) * whitePercentage);
  g = Math.floor(g + (255 - g) * whitePercentage);
  b = Math.floor(b + (255 - b) * whitePercentage);

  return `#${r.toString(16).padStart(2, "0")}${g.toString(16).padStart(2, "0")}${b.toString(16).padStart(2, "0")}`;
}

const photoName = (nameOne, nameTwo) => {
  const name = nameOne || nameTwo;
  return name?.length > 35 ? name.slice(0, 32) + "..." : name;
};

export const PhotoDetailedCard = ({
  photo,
  slot,
  handleDocPreview,
  cardWidth = 255,
  rowIndex,
  cardPositionInRow,
}) => {
  const cardWidthPx = `${cardWidth}px`;
  const userOnlineStatus = useSelector((state) => state.chat2.userOnlineStatus);

  const getCardBackground = () => {
    const isEvenRow = rowIndex % 2 === 0;
    const isEvenPosition = cardPositionInRow % 2 === 0;
    if (isEvenRow) return isEvenPosition ? "var(--primary-4)" : "var(--primary-2)";
    return isEvenPosition ? "var(--primary-2)" : "var(--primary-4)";
  };

  return (
    <div
      className="d-flex flex-column align-items-center justify-content-center"
      style={{ marginRight: "0px" }}
    >
      {photo?.page?.name === "Treatment" && (
        <div
          className="has-primary-font-detail-view-card"
          style={{
            display: "flex",
            justifyContent: photo?.panelName === null ? "center" : "flex-start",
            alignItems: "center",
            background: photo?.specialty?.color
              ? mixColorWithWhite(photo?.specialty?.color, 10)
              : "var(--primary-5)",
            color: "var(--primary)",
            width: cardWidthPx,
            minWidth: cardWidthPx,
            maxWidth: cardWidthPx,
            fontSize: "14px",
            fontWeight: "600",
            height: "25px",
            textTransform: "uppercase",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {photo?.panelName !== null && (
            <>
              <span
                className="d-flex m-r-5 align-items-center justify-content-center"
                style={{
                  width: "25px",
                  height: "25px",
                  background: photo?.specialty?.color || "#000",
                  color: "white",
                  minWidth: "25px",
                }}
              >
                {photo?.specialty?.name?.[0] || "?"}
              </span>
              <span
                style={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  fontSize: "14px",
                  fontWeight: "600",
                  height: "25px",
                  textTransform: "uppercase",
                  alignContent: "center",
                }}
              >
                {photo.panelName}
              </span>
            </>
          )}

          {photo?.panelName === null && (
            <>
              <span
                className="m-l-2"
                style={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  fontSize: "14px",
                  fontWeight: "600",
                  height: "25px",
                  textTransform: "uppercase",
                  alignContent: "center",
                }}
              >
                {slot?.slot_number === 0
                  ? "Attach to Page"
                  : slot?.slot_name === null
                    ? `${slot?.slot_number}. ${photo?.title}`
                    : slot
                      ? `${slot?.slot_number}. ${slot?.slot_name}`
                      : "Attach to Page"}
              </span>
            </>
          )}
        </div>
      )}
      {photo?.page?.name !== "Treatment" && (
        <div
          className="has-primary-font-detail-view-card"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "0px 10px",
            background: "var(--primary-5)",
            color: "var(--primary)",
            width: cardWidthPx,
            minWidth: cardWidthPx,
            maxWidth: cardWidthPx,
            fontSize: "14px",
            fontWeight: "600",
            height: "25px",
            textTransform: "uppercase",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          <span
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              flex: 1,
              textAlign: "center",
            }}
          >
            {photo?.page?.name ? (
              photo.page?.name === "Treatment" ? (
                <>
                  <span>{photo?.specialty?.name?.[0]}</span> {photo?.panelName}
                </>
              ) : photo?.panelName ? (
                photo.panelName
              ) : slot?.slot_number === 0 ? (
                "Attach to Page"
              ) : slot?.slot_name === null ? (
                `${slot?.slot_number}. ${photo?.title}`
              ) : slot?.slot_name ? (
                `${slot?.slot_number}. ${slot?.slot_name}`
              ) : (
                "Attach to Page"
              )
            ) : (
              "Unsorted Photo"
            )}
          </span>
        </div>
      )}
      <div
        className={"font-weight-semibold cursor-pointer p-0 updated-empty-card border-0"}
        id="no-vertical-border"
        onClick={() => handleDocPreview(photo)}
        style={{
          width: cardWidthPx,
          minWidth: cardWidthPx,
          maxWidth: cardWidthPx,
          background: getCardBackground(),
        }}
        key={photo.id}
      >
        <div
          title={photo.title || slot?.slot_name}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "5px",
            padding: "0 5px",
          }}
        >
          <span
            className=""
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img
              src="https://simplefirm-bucket.s3.amazonaws.com/static/images/photo-icon-color_2CyRX1a_GgdCtlG.svg"
              className="ic ic-19 cursor-pointer img-19px"
            />
          </span>
          <p
            className="name new-view-title p-0"
            style={{
              alignContent: "center",
            }}
          >
            {slot?.slot_number === 0 ? "" : slot === null ? "" : `${slot?.slot_number} .`}{" "}
            {photoName(photo?.title, slot?.slot_name)}
          </p>
        </div>
        <div
          style={{
            height: "234px",
            maxHeight: "234px",
            overflow: "hidden",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            padding: "5px",
          }}
        >
          {photo?.image ? (
            <Img
              src={photo?.image}
              unloader={<BrokenPreviewImage />}
              style={{ height: 224, width: cardWidth - 10, objectFit: "contain" }}
            />
          ) : (
            <BrokenPreviewImage />
          )}
        </div>
        <div>
          <div className="updated-empty-card-sub-head first-sub-head mt-0 p-l-5 p-r-5">
            <div
              className="d-flex align-items-center"
              style={{
                gap: "5px",
              }}
            >
              <p
                className=""
                style={{
                  color: "var(--primary-25)",
                  fontWeight: "600",
                }}
              >
                Size:
              </p>
              <p
                className=""
                style={{
                  fontWeight: "600",
                  textTransform: "lowercase",
                }}
              >
                {photo?.photo_size}
              </p>
            </div>
            <div
              className="d-flex align-items-center"
              style={{
                gap: "5px",
              }}
            >
              <p
                className=""
                style={{
                  color: "var(--primary-25)",
                  fontWeight: "600",
                }}
              >
                {/*  */}
              </p>
              <p
                style={{
                  fontWeight: "600",
                }}
              >
                {/* {doc?.page_count} */}
              </p>
            </div>
          </div>
          <div className="updated-empty-card-sub-head p-l-5 p-r-5">
            <div
              className="d-flex align-items-center"
              style={{
                gap: "5px",
              }}
            >
              <p
                style={{
                  color: "var(--primary-25)",
                  fontWeight: "600",
                }}
              >
                Date:
              </p>
              <p
                style={{
                  fontWeight: "600",
                }}
              >
                {formatDateForPanelDisplay(photo?.date_uploaded)}
              </p>
            </div>
            <div
              className="d-flex align-items-center"
              style={{
                gap: "5px",
              }}
            >
              <p
                style={{
                  color: "var(--primary-25)",
                  fontWeight: "600",
                }}
              >
                Time:
              </p>
              <p
                style={{
                  fontWeight: "600",
                }}
              >
                {(() => {
                  const time = new Date(photo.date_uploaded).toLocaleString("en-US", {
                    hour: "numeric",
                    minute: "2-digit",
                    hour12: true,
                  });
                  const [timePart, meridiem] = time.split(" ");
                  return (
                    <>
                      {timePart} <span style={{}}>{meridiem.toLowerCase()}</span>
                    </>
                  );
                })()}
              </p>
            </div>
          </div>
          <div className="updated-empty-card-sub-head w-100">
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                height: "21px",
                alignItems: "center",
              }}
              className="w-100"
            >
              <UserChatBubble
                userId={photo?.attached_by?.id}
                first_name={photo?.attached_by?.first_name || ""}
                last_name={photo?.attached_by?.last_name || ""}
                profilePic={photo?.attached_by?.profile_pic_29p ?? ""}
                is_active={photo?.attached_by?.is_active}
                width={19}
                height={25}
                isActive={userOnlineStatus?.[photo?.attached_by?.id]?.isOnline ?? false}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
